import api from '../..'
import { faker } from '@faker-js/faker'

var fakerData = [...Array(20)].map((v, index) => {
    return {
        id: index + 1,
        firstName: faker.person.firstName(),
        lastName: faker.person.lastName(),
        username: faker.internet.userName(),
        active: parseInt(faker.number.binary())
    }
})
var fakerResponse = {
    data: fakerData
}

const requests = {
    create: async (payload) => {
        var response = await api.post(`/maarima/User`, payload)
        return response.data
    },
    update: async (payload) => {
        var response = await api.put(`/maarima/User/${payload.id}`, payload)
        return response.data
    },
    fetch: async ({ search, sortKey, sortType, pageSize, pageNo }) => {
        var response = await api.get(`/maarima/User`, {
            params: {
                search,
                sortKey,
                sortType,
                pageSize,
                pageNo
            }
        })

        return response.data
    },
    fetchById: async (id) => {
        var response = await api.get(`/maarima/User/${id}`)
        return response.data
    },
    assignRole: async (userId, role) => {
        var response = await api.put(`/maarima/User/${userId}/Role`, {
            role: role.id
        })
        return response.data
    },
    removeRole: async (userId, role) => {
        var response = await api.delete(`/maarima/User/${userId}/Role`, {
            data: {
                role: role
            }
        })
        return response.data
    },
    activate: async (id) => {
        var response = await api.put(`/maarima/User/${id}/Activate`)
        return response.data
    },
    deactivate: async (id) => {
        var response = await api.put(`/maarima/User/${id}/Deactivate`)
        return response.data
    }
}

export default requests
